import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

interface useGetNewsletterViewInterface {
  newsletterId: NewsletterId
}

export function useGetNewsletterView({ newsletterId }: useGetNewsletterViewInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, NewsletterViewApiType>({
    method: RequestMethodsEnum.get,
  })

  const { data: newsletterData, mutate: mutateNewslettersData } = useControlledSwr(
    [`${NEWSLETTERS_API}/${newsletterId}`, RequestModuleEnum.Tags],
    fetcher,
    undefined,
    !!user,
  )

  return { newsletterData, mutateNewslettersData }
}
